import React, { useState, useEffect } from "react";
import {
  AppBar,
  Toolbar,
  Typography,
  Button,
  useMediaQuery
} from "@mui/material";

import { useTheme } from "@mui/material/styles";
import { Link, useNavigate } from "react-router-dom";

import Tooltip from '@mui/material/Tooltip';
import AssignmentIcon from '@mui/icons-material/Assignment';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import LogoutIcon from "@mui/icons-material/Logout";
import EmailIcon from "@mui/icons-material/Email"; // 🔥 NUEVO
import BusinessIcon from "@mui/icons-material/Business";

import { peticionGet } from "Componentes/ComponenteAxios";
import Avatar from "@mui/material/Avatar";

const BarraNavegacion = ({ titulo, onLogout }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const navigate = useNavigate();

  const [user, setUser] = useState(null);

  useEffect(() => {
    peticionGet("/settings").then(({ peticion, error }) => {
      if (!error) {
        setUser(peticion);
      }
    });
  }, []);

  return (
    <AppBar position="static">
      <Toolbar>
        <Typography
          variant="h6"
          sx={{
            flexGrow: 1,
            cursor: "pointer",
          }}
          onClick={() => navigate("/")}
        >
          {isMobile ? "Encuestix" : titulo || "Encuestix.com"}
        </Typography>

        <Tooltip title="Encuestas">
          <Button
            color="inherit"
            component={Link}
            to="/ListSurveys"
            startIcon={<AssignmentIcon />}
            aria-label="Encuestas"
          />
        </Tooltip>

        <Tooltip title="Plantillas">
          <Button
            color="inherit"
            component={Link}
            to="/Templates"
            startIcon={<ContentCopyIcon />}
            aria-label="Plantillas"
          />
        </Tooltip>

        {/* 🔥 NUEVO BOTÓN */}
        <Tooltip title="Moderación envíos">
          <Button
            color="inherit"
            component={Link}
            to="/EmailLogs"
            startIcon={<EmailIcon />}
            aria-label="Moderacion envios"
          />
        </Tooltip>

        {user?.user_id === 1 && (
          <Tooltip title="Empresas">
            <Button
              color="inherit"
              component={Link}
              to="/Companies"
              startIcon={<BusinessIcon />}
              aria-label="Empresas"
            />
          </Tooltip>
        )}

        <Tooltip title={user?.company_name || user?.user_name || "Usuario"}>
          <Avatar
            src={user?.company_logo_url || ""}
            onClick={() => navigate("/settings")}
            sx={{ width: 32, height: 32, ml: 1, cursor: "pointer" }}
          >
            {!user?.company_logo &&
              (
                user?.company_name?.charAt(0)?.toUpperCase() ||
                user?.user_name?.charAt(0)?.toUpperCase() ||
                "U"
              )
            }
          </Avatar>
        </Tooltip>

        <Tooltip title="Logout">
          <Button
            color="inherit"
            onClick={onLogout}
            startIcon={<LogoutIcon />}
            aria-label="Logout"
          />
        </Tooltip>
      </Toolbar>
    </AppBar>
  );
};

export default BarraNavegacion;